import React from "react";
import PhoneNumberHeader from "./PhoneNumberHeader";
import PhoneNumberDetails from "./PhoneNumberDetails";
import { formatUSPhoneNumber } from "../../../../utils/formatters";

const PhoneDetailsDrawerContent = ({
  phoneData,
  onAssignUser,
  onAssignExtension,
  onAssignDepartment,
  onAssignLocation,
  refetch,
  canAssignLocation,
}) => {
  return (
    <>
      <PhoneNumberHeader
        phoneNumber={formatUSPhoneNumber(phoneData?.phoneNumber)}
        name={phoneData?.name}
        status={phoneData?.isActive ? "Active" : "Inactive"}
      />
      <div className="mt-8">
        <PhoneNumberDetails
          phoneData={phoneData}
          refetch={refetch}
          onAssignUser={onAssignUser}
          onAssignExtension={onAssignExtension}
          onAssignDepartment={onAssignDepartment}
          onAssignLocation={onAssignLocation}
          canAssignLocation={canAssignLocation}
        />
      </div>
    </>
  );
};

export default PhoneDetailsDrawerContent;
